import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class FeatureDetectService {
    cssGrid: boolean;

    constructor(@Inject(DOCUMENT) private doc: Document) {}

    detectFeatures() {
        const el = this.doc.createElement('div');
        el.style.display = 'grid';
        this.cssGrid = el.style.display === 'grid';
    }
}
